module.exports = __webpack_public_path__ + "static/koneser-1f6913bbaec6adcf2f8a80515ac5fa93.png";